import styled from 'styled-components';

export const ButtonWrapper = styled.div`
  cursor: pointer;
`;
